import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cake, PartyPopper } from "lucide-react";
import { api } from "../lib/api";

const formatDay = (iso) =>
  new Date(iso + "T12:00:00").toLocaleDateString("it-IT", { day: "numeric", month: "long" });

const whenText = (b) => {
  if (b.is_today) return `Oggi compie ${b.turning} ${b.turning === 1 ? "anno" : "anni"}!`;
  if (b.days_until === 1) return `Domani compie ${b.turning} ${b.turning === 1 ? "anno" : "anni"}`;
  return `${formatDay(b.next_birthday)} · compie ${b.turning} ${b.turning === 1 ? "anno" : "anni"}`;
};

export const UpcomingBirthdays = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/dogs/birthdays/upcoming").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section data-testid="upcoming-birthdays" className="mb-12 rounded-3xl border border-[#E8DFD5] bg-white p-6 sm:p-8">
      <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#B85328]">
        <Cake size={13} /> Compleanni in vista
      </p>
      <p className="mt-2 text-sm text-[#8C7B6E]">Passa dal diario per lasciare un augurio alla famiglia.</p>
      <div className="mt-5 flex gap-4 overflow-x-auto pb-2">
        {items.map((b) => (
          <Link
            key={b.dog_name}
            to={`/cani/${encodeURIComponent(b.dog_name)}`}
            data-testid={`birthday-card-${b.dog_name.toLowerCase()}`}
            className={`group flex min-w-[220px] flex-col gap-2 rounded-2xl border px-5 py-4 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg ${
              b.is_today ? "border-[#B85328] bg-[#B85328] text-[#FBF8F3]" : "border-[#E8DFD5] bg-[#FBF8F3] text-[#2C2723] hover:border-[#B85328]/50"
            }`}
          >
            <span className="flex items-center gap-2 font-display text-xl font-semibold">
              {b.is_today && <PartyPopper size={18} />}
              {b.dog_name}
            </span>
            <span data-testid={`birthday-when-${b.dog_name.toLowerCase()}`} className={`text-xs font-semibold ${b.is_today ? "text-[#FBF8F3]/90" : "text-[#8C7B6E]"}`}>
              {whenText(b)}
            </span>
            {!b.is_today && (
              <span className="text-[10px] uppercase tracking-[0.15em] text-[#B85328]">
                tra {b.days_until} {b.days_until === 1 ? "giorno" : "giorni"}
              </span>
            )}
          </Link>
        ))}
      </div>
    </section>
  );
};
